<template>
    <div class="divider-generic-wrapper" :class="[{'apply-border': applyBorder}, dividerSize]">
        <divider-icon v-if="icon" class="divider-icon"/>
        <div v-if="title" class="divider-title">
            {{title}}
        </div>
    </div>
</template>

<script setup>
/* Imports */
import { computed, defineAsyncComponent } from 'vue'

/** props received
@title { String }
@icon { String }
@applyBorder { Boolean }
@dividerSize {String} can be [small, medium, large(default) ]
*/
const props = defineProps({
	title: String,
	icon: String,
    applyBorder: { type: Boolean, default: () => true },
    dividerSize: { type: String, default: 'large' }
})
/* Computed */
const dividerIcon = computed(() => {
	return defineAsyncComponent(() => import('@/assets/icons/' + props.icon + '.svg?inline'))
})
</script>

<style lang="scss" scoped>
.divider-generic-wrapper {
    width: 100%;

    display: flex;
    align-items: flex-start;
    gap: 8px;

    &.apply-border {
        border-top: 1px solid var(--secondary-light-2);
        padding-top: 24px;
    }

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        margin-top: 2px;

        :deep(.change-color-fill) {
            fill: var(--secondary-dark-2);
        }
    }

    .divider-title {
        min-height: 16px;

        text-align: left;
        line-height: 22px;
        color: var(--primary);
    }

    &.large {
        .divider-title {
            @include H4-Medium;
        }
    }

    &.medium {
        .divider-title {
            @include H5-Medium;
        }
    }

    &.small {
        .divider-title {
            @include H7-Medium;
            color: var(--secondary-dark-2);
        }
    }
}
</style>
